import React from 'react';
import './MailTo.scss';
import { Props } from './interfaces';

const MailTo = ({ mail, tag = 'p' }: Props) => {
  return (
    <a
      className="mailTo"
      href={`mailto:${mail}`}
      target="_blank"
      dangerouslySetInnerHTML={{ __html: `<${tag}>${mail}</${tag}>` }}
    ></a>
  );
};

export default MailTo;
